(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-featured-review"] && !Shopify.designMode) return;
  try {
    
  (()=>{window.rvPlaceBuySections?.();const reduced=false;const init=root=>{if(root.dataset.ready==='true')return;root.dataset.ready='true';const track=root.querySelector('[data-rv-featured-track]');const cards=Array.from(root.querySelectorAll('[data-rv-featured-card]'));const dots=Array.from(root.querySelectorAll('.rv-featured__dots span'));let index=0;const show=next=>{if(!track||cards.length<2)return;index=next%cards.length;track.scrollTo({left:cards[index].offsetLeft-cards[0].offsetLeft,behavior:reduced?'auto':'smooth'});dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index))};if(!reduced&&cards.length>1)window.setInterval(()=>show(index+1),Number(root.dataset.interval||5)*1000)};document.querySelectorAll('[data-rv-featured]').forEach(init);if(!window.rvFeaturedBound){window.rvFeaturedBound=true;document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-rv-featured]');if(root)init(root);requestAnimationFrame(window.rvPlaceBuySections)})}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-social-proof"] && !Shopify.designMode) return;
  try {
    
  (()=>{window.rvPlaceBuySections=()=>{const info=document.querySelector('[id^="ProductInfo-"]');const form=info?.querySelector('product-form');if(!form)return;const badges=info.querySelector('.payment-badges-block');if(badges&&form.nextElementSibling!==badges)form.insertAdjacentElement('afterend',badges);let anchor=badges||form;Array.from(document.querySelectorAll('[data-rv-buy-slot]')).sort((a,b)=>Number(a.dataset.rvBuySlot)-Number(b.dataset.rvBuySlot)).forEach(root=>{if(anchor.nextElementSibling!==root)anchor.insertAdjacentElement('afterend',root);anchor=root})};window.rvPlaceBuySections();if(!window.rvPurchasePlacementBound){window.rvPurchasePlacementBound=true;document.addEventListener('shopify:section:load',()=>requestAnimationFrame(window.rvPlaceBuySections))}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (()=>{window.rvPlaceBuySections?.();const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const init=root=>{if(root.dataset.ready==='true')return;root.dataset.ready='true';const viewport=root.querySelector('[data-rv-ugc-viewport]');const cards=Array.from(root.querySelectorAll('[data-rv-ugc-card]'));let index=0;const show=next=>{if(!viewport||cards.length<2)return;index=(next+cards.length)%cards.length;viewport.scrollTo({left:cards[index].offsetLeft,behavior:reduced?'auto':'smooth'})};root.querySelector('[data-rv-ugc-previous]')?.addEventListener('click',()=>show(index-1));root.querySelector('[data-rv-ugc-next]')?.addEventListener('click',()=>show(index+1));if(!reduced&&cards.length>1&&!Shopify.designMode)window.setInterval(()=>show(index+1),Number(root.dataset.interval||6)*1000)};document.querySelectorAll('[data-rv-ugc]').forEach(init);if(!window.rvUgcBound){window.rvUgcBound=true;document.addEventListener('shopify:section:load',event=>{const root=event.target.querySelector('[data-rv-ugc]');if(root)init(root);requestAnimationFrame(window.rvPlaceBuySections)})}})();

  } catch(e) { console.error(e); }
})();
})();
